import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Internet } from "@Icons/payments/Internet.svg";

const LangToggle = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language.split("-")[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const capitalizeFirstLetter = (string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
  };

  const handleLanguageChange = (newLanguage) => {
    i18n.changeLanguage(newLanguage);
    localStorage.setItem("locale", newLanguage);
    setLanguage(newLanguage);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const locale = localStorage.getItem("locale");
    if (locale) {
      i18n.changeLanguage(locale);
      setLanguage(locale.split("-")[0]);
    }

    const handleLanguageChanged = (lng) => {
      setLanguage(lng.split("-")[0]);
    };

    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [i18n]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".relative")) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      <button onClick={toggleDropdown} className="flex items-center space-x-0.5 focus:outline-none">
        <span className="text-sm font-medium text-link">{capitalizeFirstLetter(language)}</span>
        <Internet />
      </button>
      {isDropdownOpen && (
        <div className="absolute right-0 z-20 mt-2 rounded border border-gray-300 bg-white shadow-lg">
          <div
            onClick={() => handleLanguageChange("en")}
            className={`cursor-pointer p-2 hover:bg-gray-200 ${language === "en" ? "font-bold" : ""}`}
          >
            EN
          </div>
          <div
            onClick={() => handleLanguageChange("ru")}
            className={`cursor-pointer p-2 hover:bg-gray-200 ${language === "ru" ? "font-bold" : ""}`}
          >
            RU
          </div>
          <div
            onClick={() => handleLanguageChange("kk")}
            className={`cursor-pointer p-2 hover:bg-gray-200 ${language === "kk" ? "font-bold" : ""}`}
          >
            KZ
          </div>
          <div
            onClick={() => handleLanguageChange("az")}
            className={`cursor-pointer p-2 hover:bg-gray-200 ${language === "az" ? "font-bold" : ""}`}
          >
            AZ
          </div>
          <div
            onClick={() => handleLanguageChange("fr")}
            className={`cursor-pointer p-2 hover:bg-gray-200 ${language === "fr" ? "font-bold" : ""}`}
          >
            FR
          </div>
          <div
            onClick={() => handleLanguageChange("ar")}
            className={`cursor-pointer p-2 hover:bg-gray-200 ${language === "ar" ? "font-bold" : ""}`}
          >
            AR
          </div>
        </div>
      )}
    </div>
  );
};

export default LangToggle;
